import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import IP_Page from "../../images/IP_Page.png";
// import FilmDetails from './FilmDetails/FilmDetails';
import StepLabel from "@mui/material/StepLabel";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { convertDate } from "../Helper";
import DetailsOfWebSeries from "./DetailsOfWebSeries/DetailsOfWebSeries";
import Season from "./Season/Season";
import Producer from "./Producer/Producer";
import OttPlatform from "./OttPlatform/OttPlatform";
import DirectorAndCreatorDetails from "./DirectorAndCreatorDetails/DirectorAndCreatorDetails";
import Documents from "./Documents/Documents";
import Declaration from "../ip/Declaration/Declaration";
import DeclarationAndPayment from "./DeclarationAndPayment/DeclarationAndPayment";

import { useMediaQuery, useTheme } from "@mui/material";
import ApiClient from "../common/ApiClient";

import Preview from "./OttPreview/Preview";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
// import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Loader from "../common/Loader/Loader";
import OttSubmission from "./OttSubmission/OttSubmission";
import { validateEmail } from "../Helper";
import { Container } from "@mui/material";
// import logo from '../../images/pecock.png';
import logo from "../../assets/images/IFFFI_LOGO.png";
import logo1 from "../../images/ashok-logo.png";
import logo2 from "../../assets/images/NFDC-Logo.png";
import AlertMessage from "../AlertMessage";
import CheckIcon from "@mui/icons-material/Check";
import ashok from "../../assets/images/ashok_logo.png";
import { OttData, CommonData } from "../../Config/Config";
import { isTimeUp } from "../Helper";

const { OttSubDate, OttSubTime, OttDocDate, OttDocTime } = OttData();
const { year } = CommonData();

const steps = [
  "Details Of Web Series",
  "Season & Episodes",
  "Producer(s)",
  "OTT Platform",
  "Director(s)/Creator(s) ",
  "Documents",
  "Preview",
  "Declaration & Payment",
  "Submission",
];
const OttStepperData = () => {
  const [impoData, setImpoData] = useState([]);
  let baseUrl = process.env.REACT_APP_BASE_PREFIX;
  useEffect(() => {
    const ImportantData = async () => {
      if (!baseUrl) {
        return;
      }
      try {
        const response = await fetch(`${baseUrl}/AppData.json`);
        const commonData = await response.json();
        setImpoData(commonData);
        if (commonData) {
          setAlertData({
            heading: (
              <>
                <h5>Note:</h5>
              </>
            ),
            content: (
              <>
                <div>
                  <p>
                    (1) Please exercise great care in filling out this form as
                    it is the primary source of data for the Ministry with
                    respect to this award, and no requests for a change of
                    details will be entertained at any stage. The information
                    provided will be used for the evaluation and selection
                    process.
                  </p>
                  <p>
                    (2) Before filling out the form, kindly read the award
                    regulations available on the website{" "}
                    <b>www.mib.gov.in, www.iffigoa.org, www.nfdcindia.com</b>{" "}
                    carefully.
                  </p>
                  <p>
                    (3) The Entry Form must be filled out by the ‘Applicant’ as
                    defined in the Regulations.
                  </p>
                  <p>
                    (4) Only one season of the web series will be considered for
                    the award as per the Regulations. If multiple seasons of a
                    web series are released within the eligibility period, the
                    applicant must ensure that the information provided in the
                    form is relevant only to the season applied for the award.
                  </p>
                  <p>
                    (5) The Applicant must also ensure that the name(s)
                    indicated in the entry form match the credit titles
                    appearing in the web series, as the credit titles will be
                    considered for validation if required.
                  </p>
                  <p>
                    (6) The last date for submission of online applications is
                    &nbsp;
                    <b>
                      {commonData?.ott?.last_date} till{" "}
                      {commonData?.ott?.last_time}
                    </b>
                    , and the last date for the receipt of the stamped and
                    signed hard copy of the submitted online application form
                    along with the requisite material is &nbsp;
                    <b>
                      {commonData?.ott?.last_document} till{" "}
                      {commonData?.ott?.last_time}
                    </b>{" "}
                    . In the event that the physical submission deadline is
                    declared a holiday, the next working day will be considered
                    as the final date for receipt of the application. (Note:
                    Both the online and hard copy versions of the application
                    forms must be the same.) Digital signature on original documents to be submitted are not acceptable.
                  </p>
                  <p>
                    (7) The submission of Online streaming link (vimeo or google drive or similar platform link) of all the episodes of submitted web series is mandatory and it shouldn't be changed or deleted until the last of the festival i.e. <b>28 November, 2026</b>.
                  </p>
                </div>
              </>
            ),
          });
          handleClickOpen();
        }
      } catch (error) {
        console.error(error, "importent adta error");
      }
    };

    ImportantData();
  }, []);

  const [loading, setLoading] = useState(false);
  const { postRequest, getRequest } = ApiClient();
  const { id = null, ip_step = 1 } = useParams();

  const [predata, setPredata] = useState({});
  const [datatest, setDatatest] = useState(null);
  const dashboardnavi = useNavigate();
  const verifyExistingRecord = async () => {
    if (id) return true;

    const predata = await getRequest("ott");
    const data = predata.data;
    if (data.length > 1) {
      alert("You have reached maximum limit.");
      dashboardnavi("/dashboard");
    }
  };
  const loadpreData = async () => {
    if (id) {
      try {
        const predata = await getRequest(`ott/${id}`, {});
        const loadpredata = predata.data;

        setActiveStep(loadpredata.step);
        const documentData = {};
        if (loadpredata.documents) {
          for (const document of loadpredata.documents) {
            if (document.documents_type == 1)
              loadpredata.is_synopsis_profile = 1;
            else if (document.documents_type == 2)
              loadpredata.is_creator_profile = 1;
            else if (document.documents_type == 3)
              loadpredata.is_director_profile = 1;
            else if (document.documents_type == 4)
              loadpredata.is_brief_profile_of_producer = 1;
            else if (document.documents_type == 5)
              loadpredata.is_incorporation_registration_in_india = 1;
            else if (document.documents_type == 7)
              loadpredata.is_incorporation_registration_in_foreign = 1;
            else if (document.documents_type == 9)
              loadpredata.is_schedule_one = 1;

            documentData[document.documents_type] = {
              file: document.file,
              name: document.documents_name,
            };
          }
        }
        loadpredata.documentData = documentData;
        // console.log({ documentData })
        setFormData({
          ...loadpredata,
          release_date: dayjs(loadpredata.release_date),
          // date: dayjs(loadpredata.date),
          // date_of_completion_production: dayjs(loadpredata.date_of_completion_production),
        });
        setPredata(predata.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false); // Ensure loading is set to false even if an error occurs
      }
    }
  };

  useEffect(() => {
    // Show modal when component mounts
    // console.log("1st use effect")
    //  verifyExistingRecord(); // Ensure this function is defined and working correctly
    loadpreData();

    setActiveStep(parseInt(ip_step - 1));
  }, []);

  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  //console.log(activeStep, "activeStepDetails")
  const [completed, setCompleted] = useState({});
  // console.log(completed, "completed")

  const [formData, setFormData] = useState({});

  // const [filmErrors, setFilmErrors] = useState({});
  const [webSeriesErrors, setWebSeriesErrors] = useState({});
  const [seasonEpisodeErrors, setSeasonEpisodeErrors] = useState({});
  const [producerErrors, setProducerErrors] = useState({});
  const [ottPlatformErrors, setOttPlatformErrors] = useState({});
  const [directorErrors, setDirectorErrors] = useState({});
  const [crewErrors, setCrewErrors] = useState({});
  const [cbfcErrors, setCbfcErrors] = useState({});
  const [otherErrors, setOtherErrors] = useState({});
  const [directorCreatorErrors, setDirectorCreatorErrors] = useState({});
  const [documentErrors, setDocumentErrors] = useState({});

  const totalSteps = () => {
    return steps.length;
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = async () => {
    //  console.log("dsfdfds")

    const newCompleted = { ...completed };
    newCompleted[activeStep] = true;
    //  handleNext();
    // console.log({ activeStep })

    if (activeStep === 0) {
      const { isValid, errors } = validateDetailsOfWebSeries(formData);
      // console.log(errors);
      if (!isValid) {
        setWebSeriesErrors(errors);
        return;
      }
      setLoading(true);
      try {
        let response;
        // console.log({ formData }, "ott stepper")
        if (id) {
          response = await postRequest(`ott/${id}`, { ...formData, step: 1 });
        } else {
          response = await postRequest("ott", { ...formData, step: 1 });
        }

        if (response.status && !id) {
          navigate(`/ott/${response.data.id}`);
          setActiveStep(1);
        } else if (response.status && id) {
          handleNext();
        } else {
          alert(response.message);
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 800);
      }
      // formData.step=1;
      // await postRequest("ip_applcation_form",formData);
    }

    if (activeStep === 1) {
      // Validation for the Producer Details step
      const { isValidSeasonEpisode, errorsSeasonAndEpisode } =
        validateSeasonAndEpisode(formData);
      // console.log(isValidProducer, "isValidProducer")
      // console.log(errorsSeasonAndEpisode)
      if (!isValidSeasonEpisode) {
        setSeasonEpisodeErrors(errorsSeasonAndEpisode);
        return; // Stop execution if validation fails
      }

      // formData.step=2;
      // await postRequest("ip_applcation_form",formData);

      if (!id) {
        console.error("ID is not available.");
        return;
      }
      const updatedFormData = {
        ...formData,
        step: 2,
      };
      // console.log({ updatedFormData });
      setLoading(true);
      try {
        updatedFormData.release_date = convertDate(
          updatedFormData.release_date,
        );
        const producer_data_check = await postRequest(
          `ott/${id}`,
          updatedFormData,
        );

        if (producer_data_check.status) handleNext();
        else {
          alert(producer_data_check.message);
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false); // Set loading to false when the API call finishes
      }
    }

    if (activeStep === 2) {
      // console.log("validateProducerDetails");
      // Validation for the Producer Details step
      const { isValidProducer, errorsProducer } =
        validateProducerDetails(formData);
      // console.log(isValidProducer, "isValidProducer")
      // console.log(errorsProducer)
      if (!isValidProducer) {
        setProducerErrors(errorsProducer);
        return; // Stop execution if validation fails
      }

      // formData.step=2;
      // await postRequest(`ott/${id}`,formData);

      if (!id) {
        console.error("ID is not available.");
        return;
      }
      const updatedFormData = {
        ...formData,
        step: 3,
      };
      // console.log({ updatedFormData });
      setLoading(true);
      try {
        const producer_data_check = await postRequest(
          `ott/${id}`,
          updatedFormData,
        );

        if (producer_data_check.status) handleNext();
        else {
          alert(producer_data_check.message);
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false); // Set loading to false when the API call finishes
      }
    }

    if (activeStep === 3) {
      // Validation for the Director Details step
      const { isValidOttPlatform, errorsOttPlatform } =
        validateOttPlatformDetails(formData);
      // console.log(isValidOttPlatform, "isValidOttPlatform")
      // console.log(errorsOttPlatform)
      if (!isValidOttPlatform) {
        setOttPlatformErrors(errorsOttPlatform);
        return;
      }

      if (!id && false) {
        console.error("ID is not available.");
        return;
      }
      const updatedFormData = {
        ...formData,
        step: 4,
      };
      setLoading(true);
      try {
        const producer_data_check = await postRequest(
          `ott/${id}`,
          updatedFormData,
        );
        // console.log(producer_data_check);
        if (producer_data_check.status) handleNext();
        else {
          alert(producer_data_check.message);
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false); // Set loading to false when the API call finishes
      }
    }

    if (activeStep === 4) {
      // console.log("errorsDirectorAndCreator");
      // Validation for the CBFC Certification Details step
      const { isValidDirectorAndCreator, errorsDirectorAndCreator } =
        validateDirectorAndCreatorDetails(formData);
      // console.log(isValidCbfc, "isValidCbfc")
      // console.log(errorsDirectorAndCreator)

      if (!isValidDirectorAndCreator) {
        setDirectorCreatorErrors(errorsDirectorAndCreator);
        return;
      }
      if (!id) {
        console.error("ID is not available.");
        return;
      }
      const updatedFormData = {
        ...formData,
        step: 5,
      };
      // try {
      //     await postRequest(`ott/${id}`, updatedFormData);
      // } catch (error) {
      //     console.error("Error:", error);
      // } convertDate
      setLoading(true);
      try {
        updatedFormData.date_of_cbfc_certificate = convertDate(
          updatedFormData.date_of_cbfc_certificate,
        );
        updatedFormData.date_of_completion_production = convertDate(
          updatedFormData.date_of_completion_production,
        );
        const producer_data_check = await postRequest(
          `ott/${id}`,
          updatedFormData,
        );

        if (producer_data_check.status) handleNext();
        else {
          alert(producer_data_check.message);
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false); // Set loading to false when the API call finishes
      }
    }

    if (activeStep === 5) {
      // console.log("step 5")
      const { isValidDocument, errorsDocument } =
        validateDocumentDetails(formData);

      if (!isValidDocument) {
        setDocumentErrors(errorsDocument);
        return;
      }
      if (!id) {
        console.error("ID is not available.");
        return;
      }
      const updatedFormData = {
        ...formData,
        step: 6,
      };
      setLoading(true);

      try {
        const producer_data_check = await postRequest(
          `ott/${id}`,
          updatedFormData,
        );

        if (producer_data_check.status) handleNext();
        else {
          alert(producer_data_check.message);
          return 0;
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false); // Set loading to false when the API call finishes
      }
    }

    if (activeStep === 6) {
      // console.log("step 6")
      //   handleNext();
      const updatedFormData = {
        ...formData,
        step: 7,
      };
      setLoading(true);

      try {
        const producer_data_check = await postRequest(
          `ott/${id}`,
          updatedFormData,
        );

        if (producer_data_check.status) handleNext();
        else {
          alert(producer_data_check.message);
          // console.log(producer_data_check.message, "Step 7 Data")
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false); // Set loading to false when the API call finishes
      }
    }

    if (activeStep === steps.length - 1) {
      // Final step, make the API call
      await submitFormData();
    } else {
      ///  x
    }
    //handleNext();

    loadpreData();
  };

  const timeUpHandler = () => {
    if (impoData.ott.close === 0) {
      alert("Time is up! You can no longer proceed.");
      navigate("/dashboard");
    } else {
      handleComplete();
    }
  };

  const CustomStepLabel = ({ children }) => {
    return (
      <StepLabel StepIconComponent={() => null} className="custom-step-label">
        {children}
      </StepLabel>
    );
  };

  const submitFormData = async () => {
    try {
      const payload = {
        ...formData,
      };
      // const data = await postRequestGlobal('register', payload)
      const data = await postRequest("ip_applcation_form", payload);
      // console.log(data, "data");

      // const responseData = await response.json();
      // console.log('Success:', data);
      alert("Form submitted successfully");
    } catch (error) {
      console.error("Error:", error);
      alert("Form submission failed");
    }
  };

  const validateDetailsOfWebSeries = (formData) => {
    const {
      genre_id,
      title,
      title_in_english,
      subtitle_other_language,
      is_subtitle_language_eng,
      language_id,
      other_genre,
      other_language,
      other_subtitle_language,
    } = formData;
    const errors = {};

    if (!title) {
      errors.title = "Enter title of Web Series";
    }
    if (!title_in_english) {
      errors.title_in_english = "Enter english translation of the title";
    }
    if (!genre_id) {
      errors.genre_id = "Enter genre of Web Series";
    }

    if (genre_id == 25 && !other_genre) {
      errors.other_genre = "Enter Other genre";
    }

    if (language_id == 20 && !other_language) {
      errors.other_language = "Enter Other language";
    }

    if (subtitle_other_language == 20 && !other_subtitle_language) {
      errors.other_subtitle_language = "Enter Subtitle of other language";
    }

    if (!is_subtitle_language_eng && is_subtitle_language_eng !== 0) {
      errors.is_subtitle_language_eng = "Select one option";
    }

    if (!language_id) {
      errors.language_id = "Select language";
    }

    // if (!subtitle_other_language) {
    //     errors.subtitle_other_language = "Select language of subtitle";
    // }
    const isValid = Object.keys(errors).length === 0;

    return { isValid, errors };
  };

  const validateSeasonAndEpisode = (formData) => {
    const {
      number_of_episodes,
      is_episode_have_same_date,
      required_episode_count,
      is_episode_added = null,
      season,
      runtime,
      number_of_episode,
      is_long_duration_timing,
      release_date,
      episode_number,
      title_in_english,
      subtitle_other_language,
      is_subtitle_language_eng,
      language_id,
    } = formData;
    const errorsSeasonAndEpisode = {};

    if (is_episode_have_same_date === null) {
      errorsSeasonAndEpisode.is_episode_have_same_date =
        "This field is required.";
    }
    if (!season) {
      errorsSeasonAndEpisode.season = "Season is required";
    }
    if (!runtime) {
      errorsSeasonAndEpisode.runtime = "Total Runtime is required";
    } else {
      if (!isFinite(runtime)) {
        errorsSeasonAndEpisode.runtime = "It should be number.";
      } else {
        if (runtime < 120) {
          errorsSeasonAndEpisode.runtime =
            'Under clause  5.8 "The web series must have a total run-time of at least 120 minutes"';
        }
      }
    }

    if (!number_of_episode) {
      errorsSeasonAndEpisode.number_of_episode =
        "Number of episodes is required";
    } else {
      if (number_of_episode < 3) {
        errorsSeasonAndEpisode.number_of_episode =
          "Please add at least 3 episode.";
      }
    }
    if (!is_long_duration_timing) {
      errorsSeasonAndEpisode.is_long_duration_timing = "Select one option";
    }
    if (
      !release_date ||
      release_date == "0000-00-00" ||
      release_date == "NaN-NaN-NaN"
    ) {
      errorsSeasonAndEpisode.release_date = "Release date is required";
    } else {
      const minDate = dayjs("2025-01-01");
      const maxDate = dayjs("2026-07-31");

      if (release_date.isBefore(minDate) || release_date.isAfter(maxDate)) {
        errorsSeasonAndEpisode.release_date =
          "Date must be between 01-01-2025 and 31-07-2026";
      }
    }

    if (is_episode_have_same_date != 1) {
      if (number_of_episodes != number_of_episode) {
        const errortext =
          "Number of episodes should match with Episode Number added.";
        errorsSeasonAndEpisode.is_episode_added = errortext;
        //errorsSeasonAndEpisode.is_episode_added = `Please add at least ${required_episode_count} episodes for the season.`;
        errorsSeasonAndEpisode.number_of_episode = errortext;
      }
    }

    const isValidSeasonEpisode =
      Object.keys(errorsSeasonAndEpisode).length === 0;

    return { isValidSeasonEpisode, errorsSeasonAndEpisode };
  };

  const validateProducerDetails = (formData) => {
    const {
      is_incorporation_registration_in_india = null,
      is_incorporation_registration_in_india_multi = null,
      is_incorporation_registration_in_foreign = null,
      have_producer = null,
      has_coproduction,
      coproducer_type,
      coproducer_name,
      coproducer_address,
      coproducer_phone,
      coproducer_email,
      coproducer_is_follow_it_rules,
      coproducer_is_original_production,
      coproducer_is_registered,
      is_registered,
      coproducer_is_residing_in_country,
      incorporation_registration_in_foreign,
      nationality,
    } = formData;
    const errorsProducer = {};

    // if (
    //   !is_incorporation_registration_in_india &&
    //   (has_coproduction === "0" || has_coproduction === 0)
    // ) {
    //   if (coproducer_type == 2)
    //     errorsProducer.incorporation_registration_in_india =
    //       "Upload Proof of the incorporation/ Registration in India is required";
    // }

    if (has_coproduction == 0 && !is_incorporation_registration_in_india) {
      errorsProducer.incorporation_registration_in_india =
        "Upload proof of incorporation/registration in India is required";
    }

    if (has_coproduction == 0 && formData.coproducer_type == 2) {
      if (coproducer_is_registered == 0) {
        if (!is_incorporation_registration_in_foreign) {
          errorsProducer.incorporation_registration_in_foreign =
            "Upload proof in pdf";
        }
      }
    }

    if (has_coproduction === null) {
      errorsProducer.has_coproduction = "Select one option";
    }

    if (has_coproduction === 0 || has_coproduction === "0") {
      if (!coproducer_type) {
        errorsProducer.coproducer_type = "Select production type";
      }

      if (!coproducer_name) {
        errorsProducer.coproducer_name = " Enter your name";
      }

      if (!coproducer_address) {
        errorsProducer.coproducer_address = "Enter your address";
      }

      if (!coproducer_phone) {
        errorsProducer.coproducer_phone = "Enter your phone number";
      } else {
        if (coproducer_phone.length < 10) {
          errorsProducer.coproducer_phone =
            "Mobile number must be of 10 digits.";
        }
      }

      // if (coproducer_phone.length<10) {
      //     errorsProducer.coproducer_phone = "Enter your phone number";
      // }

      if (!coproducer_email) {
        errorsProducer.coproducer_email = "Enter your email id";
      } else if (!validateEmail(coproducer_email)) {
        errorsProducer.coproducer_email = "Email is not valid.";
      }

      //if (!coproducer_email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)) errorsProducer.coproducer_email = "Invalid email format";

      if (coproducer_is_follow_it_rules === null && coproducer_type == 1) {
        errorsProducer.coproducer_is_follow_it_rules = "Select one option";
      }

      if (!coproducer_is_original_production && coproducer_type == 1) {
        errorsProducer.coproducer_is_original_production = "Select one option";
      }

      if (coproducer_is_registered === null && coproducer_type == 2) {
        errorsProducer.coproducer_is_registered = "Select one option";
      }

      if (coproducer_is_residing_in_country === null && coproducer_type == 3) {
        errorsProducer.coproducer_is_residing_in_country = "Select one option";
      }
    } else {
      if (have_producer === null) {
        errorsProducer.have_producer = "Please add at least one co-producer.";
      }
    }

    const isValidProducer = Object.keys(errorsProducer).length === 0;

    return { isValidProducer, errorsProducer };
  };

  const validateOttPlatformDetails = (formData) => {
    const {
      ott_released_platform,
      is_other_released_platform_available,
      is_released_other_country,
      is_thretrical_screening,
      is_streamed_other_media,
      is_international_competition,
      is_streamed_country = null,
      is_international_competetions_added = null,
      is_threatical_screening_added = null,
      is_broadcasted_added = null,
      other_released_platform_available,
      release_date_format,
      date_of_festival_format,
      stream_date_format,
    } = formData;
    const errorsOttPlatform = {};

    if (is_international_competition === null) {
      errorsOttPlatform.is_international_competition = "Select one option";
    } else {
      if (is_international_competition == 1) {
        if (!is_international_competetions_added) {
          errorsOttPlatform.is_international_competetions_added =
            "Please add at least one international competetions.";
        }
      }
    }

    if (is_streamed_other_media === null) {
      errorsOttPlatform.is_streamed_other_media = "Select one option";
    } else {
      if (is_streamed_other_media == 1) {
        if (!is_broadcasted_added) {
          errorsOttPlatform.is_broadcasted_added =
            "Please add at least one threatical screening.";
        }
      }
    }
    // 1 =>0  1
    if (
      !(
        is_thretrical_screening == 1 ||
        is_thretrical_screening === "0" ||
        is_thretrical_screening === 0
      )
    ) {
      errorsOttPlatform.is_thretrical_screening = "Select one option";
    } else {
      if (is_thretrical_screening == 1) {
        if (!is_threatical_screening_added) {
          errorsOttPlatform.is_threatical_screening_added =
            "Please add at least one threatical screening.";
        }
      }
    }

    if (is_released_other_country === null) {
      errorsOttPlatform.is_released_other_country = "Select one option";
    } else {
      if (is_released_other_country == 1) {
        // console.log({ is_streamed_country })
        if (!is_streamed_country) {
          errorsOttPlatform.is_streamed_country =
            "Please add at least one streamed country.";
        }
      }
    }

    // if (ott_released_platform === null) {
    //     errorsOttPlatform.ott_released_platform = "Enter name of the OTT Platform"
    // }

    if (!ott_released_platform) {
      errorsOttPlatform.ott_released_platform =
        "Enter name of the OTT Platform";
    }

    // if (is_other_released_platform_available === null) {
    //     errorsOttPlatform.is_other_released_platform_available = "Select one option"
    // }

    if (is_other_released_platform_available === null) {
      errorsOttPlatform.is_other_released_platform_available =
        "Select one option";
    } else {
      if (is_other_released_platform_available == 1) {
        if (!other_released_platform_available) {
          errorsOttPlatform.other_released_platform_available =
            "Enter Other Platform";
        }
      }
    }

    const isValidOttPlatform = Object.keys(errorsOttPlatform).length === 0;

    return { isValidOttPlatform, errorsOttPlatform };
  };

  const validateDirectorAndCreatorDetails = (formData) => {
    const {
      is_director_added = null,
      is_creator_added = null,
      story_writer,
      screening_writer,
      director_of_photography,
      editior,
      art_director,
      costume_director,
      music_director,
      sound_designer,

      principal_cast,
    } = formData;
    const errorsDirectorAndCreator = {};

    if (!is_creator_added) {
      errorsDirectorAndCreator.is_creator_added =
        "Please add at least one Creator details.";
    }
    if (!is_director_added) {
      errorsDirectorAndCreator.is_director_added =
        "Please add at least one  Director details.";
    }

    if (!story_writer) {
      errorsDirectorAndCreator.story_writer = "This field is required";
    }
    if (!screening_writer) {
      errorsDirectorAndCreator.screening_writer = "This field is required";
    }
    if (!director_of_photography) {
      errorsDirectorAndCreator.director_of_photography =
        "This field is required";
    }
    if (!editior) {
      errorsDirectorAndCreator.editior = "This field is required";
    }
    if (!art_director) {
      errorsDirectorAndCreator.art_director = "This field is required";
    }
    if (!costume_director) {
      errorsDirectorAndCreator.costume_director = "This field is required";
    }
    if (!music_director) {
      errorsDirectorAndCreator.music_director = "This field is required";
    }
    if (!sound_designer) {
      errorsDirectorAndCreator.sound_designer = "This field is required";
    }
    if (!principal_cast) {
      errorsDirectorAndCreator.principal_cast = "This field is required";
    }

    const isValidDirectorAndCreator =
      Object.keys(errorsDirectorAndCreator).length === 0;
    return { isValidDirectorAndCreator, errorsDirectorAndCreator };
  };

  const validateDocumentDetails = (formData) => {
    const {
      is_brief_profile_of_producer = null,
      is_synopsis_profile = null,
      is_creator_profile = null,
      is_director_profile = null,
      is_producer_profile = null,
      is_schedule_one = null,
      online_link = null,
      synopsis = null,
    } = formData;
    const errorsDocument = {};

    if (!online_link) {
      errorsDocument.online_link = "online link is required";
    }

    if (!is_schedule_one) {
      errorsDocument.schedule_1 = "Schedule 1 of the Web Series is missing";
    }

    if (!synopsis) {
      errorsDocument.synopsis = "Synopsis of the Web Series is required";
    }

    if (!is_creator_profile) {
      errorsDocument.brief_profile_of_creator =
        "Brief profile of creator's is missing";
    }

    if (!is_director_profile) {
      errorsDocument.brief_profile_of_director =
        "Brief profile of Director(s) is missing";
    }

    if (!is_brief_profile_of_producer) {
      errorsDocument.brief_profile_of_producer =
        "Brief profile of Director(s) is missing";
    }

    const isValidDocument = Object.keys(errorsDocument).length === 0;
    return { isValidDocument, errorsDocument };
  };

  const handleNext = () => {
    // console.log("test")
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const isStepCompleted = (step) => {
    return completed[step];
  };

  const addCoproducer = (step) => {
    // console.log('testing sumit')
  };

  const CustomStepIconRoot = styled("div")(({ theme, ownerState }) => ({
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.grey[700]
        : theme.palette.grey[300],
    // backgroundColor: '#1c5768',
    zIndex: 1,
    color: "#1c5768",
    width: 24,
    height: 24,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    ...(ownerState.active && {
      // backgroundColor: theme.palette.primary.main,
      backgroundColor: "#1c5768",
    }),
    ...(ownerState.completed && {
      // backgroundColor: theme.palette.primary.main,
      backgroundColor: "#1c5768",
    }),
  }));

  function CustomStepIcon(props) {
    const { active, completed, className } = props;

    return (
      <CustomStepIconRoot
        ownerState={{ completed, active }}
        className={className}
      >
        {completed ? (
          <CheckIcon style={{ color: "white", fontSize: "20px" }} />
        ) : null}
        {active ? (
          <CheckIcon style={{ color: "white", fontSize: "20px" }} />
        ) : null}
      </CustomStepIconRoot>
    );
  }

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <DetailsOfWebSeries
            formData={formData}
            setFormData={setFormData}
            errors={webSeriesErrors}
            setWebSeriesErrors={setWebSeriesErrors}
          />
        );
      //<FilmDetails preData={preData} formData={formData} setFormData={setFormData} errors={filmErrors} setFilmErrors={setFilmErrors} />;
      case 1:
        return (
          <Season
            formData={formData}
            setFormData={setFormData}
            errors={seasonEpisodeErrors}
            setSeasonEpisodeErrors={setSeasonEpisodeErrors}
          />
        );
      case 2:
        return (
          <Producer
            formData={formData}
            setFormData={setFormData}
            errors={producerErrors}
            setProducerErrors={setProducerErrors}
          />
        );
      case 3:
        return (
          <OttPlatform
            datatest={datatest}
            formData={formData}
            setFormData={setFormData}
            errors={ottPlatformErrors}
            setOttPlatformErrors={setOttPlatformErrors}
          />
        );
      case 4:
        return (
          <DirectorAndCreatorDetails
            formData={formData}
            setFormData={setFormData}
            errors={directorCreatorErrors}
            setDirectorCreatorErrors={setDirectorCreatorErrors}
          />
        );
      case 5:
        return (
          <Documents
            formData={formData}
            setFormData={setFormData}
            errors={documentErrors}
            setDocumentErrors={setDocumentErrors}
          />
        );
      case 6:
        return <Preview formData={formData} setActiveStep={setActiveStep} />;
      case 7:
        return (
          <DeclarationAndPayment
            formData={formData}
            setFormData={setFormData}
          />
        );
      case 8:
        return <OttSubmission />;
      default:
        return "Unknown step";
    }
  };

  const [showModal, setShowModal] = useState(true);

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const [open, setOpen] = useState(id ? false : true);

  const [alertData, setAlertData] = useState({
    heading: "",
    content: "",
  });

  useEffect(() => {
    setShowModal(true);
  }, []);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    // Redirect to home page
    // navigate('/dashboard');
  };

  useEffect(() => {
    // setShowModal((id) ? false : true);
    setOpen(id ? false : true);
    //   timeUpHandler()
  }, []);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const handleRedirect = (tabName) => {
    navigate(`/dashboard/${tabName}`);
  };

  return (
    <>
      <AlertMessage
        handleClickOpen={handleClickOpen}
        setOpen={setOpen}
        open={open}
        handleClose={handleClose}
        data={alertData}
      />
      {loading && <Loader />}
      <Box className="steppper">
        <div className="d-flex justify-content-between m-3 align-items-center">
          <div className="imgLogo">
            <img
              src={logo1}
              alt="Logo"
              style={{ width: "120px", height: "80px" }}
            />
          </div>
          <div className="imgLogo">
            <a href={process.env.REACT_APP_BASE_PREFIX + "/dashboard"}>
              <img
                src={logo}
                alt="Logo"
                className="imgLogo"
                style={{ width: "120px", height: "80px" }}
              />
            </a>
          </div>
          {/* <div className="imgLogo logo-center" href="#home">
            <img
              src={ashok}
              width="100%"
              height="100 %"
              alt="NFDC Cinemas of India"
            />
          </div> */}
        </div>
        <Container>
          <div className=" heading-form text-center m-3">
            {/* <h5>Web Series (OTT)</h5> */}
            <h5>Best Web Series (OTT) Award, {year}</h5>
            <p> Entry Form</p>
          </div>
          <div className="m-3 d-flex justify-content-between">
            <Button variant="outlined" onClick={() => handleRedirect("ott")}>
              Dashboard
            </Button>
            <Button
              variant="outlined"
              href={process.env.REACT_APP_BASE_PREFIX + "/logout"}
              color="error"
            >
              Log Out
            </Button>
          </div>
        </Container>
        <Stepper
          activeStep={activeStep}
          orientation={isMobile ? "vertical" : "horizontal"}
          alternativeLabel={!isMobile}
          className="container pt-2"
        >
          {steps.map((label, index) => (
            <Step key={label} completed={isStepCompleted(index)}>
              <StepButton onClick={handleStep(index)}>
                <StepLabel StepIconComponent={CustomStepIcon}>
                  {label}
                </StepLabel>
                {/* <CustomStepLabel>{label}</CustomStepLabel> */}
              </StepButton>
            </Step>
          ))}
        </Stepper>
        <div className="container mt-5">
          <div className="card_con">{renderStepContent(activeStep)}</div>
          <div className="row mt-4">
            <div className="col-lg-12 text-end">
              <div className="d-flex justify-content-between mb-3">
                <Button disabled={activeStep === 0} onClick={handleBack}>
                  <ChevronLeftIcon />
                  Back
                </Button>
                {activeStep !== steps.length - 2 && (
                  <Button
                    // onClick={handleComplete}
                    onClick={timeUpHandler}
                    style={{
                      backgroundColor: isStepCompleted(activeStep)
                        ? "#4CAF50"
                        : "#1c5768",
                      color: "#fff",
                    }}
                  >
                    {activeStep === steps.length - 1 ? "Finish" : "Next"}
                    <NavigateNextIcon style={{ color: "#ffffff" }} />
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </Box>
    </>
  );
};

export default OttStepperData;
